import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DataGrid from 'react-data-grid';
import 'react-data-grid/lib/styles.css';
import '../App.css'
import { Modal, Button, Form } from 'react-bootstrap';

function Downloads(props){

    const [files,setFiles]=useState([])
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [noteValue, setNoteValue] = useState('');

    const handleRowContextMenu = (row, event) => {
        event.preventDefault();

        setSelectedRow(row);
        setNoteValue(row.notes || '');
        setShowModal(true);
    };
    
    const downloadFile = async (row) => {
    try {

        const filename=row.filename
        
        const response = await axios.post(`/downloadfile`,{ filepath: row.filepath },
        {
            responseType: 'blob', // important for file downloads
        }
        );

        // Create a URL for the file blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.error('Error downloading file:', error);
    }
    };

    const filesColDefs= [
        { key: 'index', name: 'No.',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'filename', name: 'File Name',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'country', name: 'Country',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'rowcount', name: 'Leads',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'creditsused', name: 'Credits Used',cellClass: 'cell-center', headerCellClass: 'cell-center', formatter: ({ row }) => ( Number(row.creditsused || 0).toFixed(1))},
        { key: 'exporttype', name: 'Export Type',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'date', name: 'Date', cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'notes', name: 'Description', width: 400, formatter: ({ row }) => ( <div className="cell-wrap">{row.notes}</div> ), cellClass: 'cell-center', headerCellClass: 'cell-center'},

        { key: 'filepath', name: 'Download',cellClass: 'cell-center', headerCellClass: 'cell-center',
           formatter: ({ row }) => {

            return <div style={{ textAlign: 'center' }}><span onClick={()=>downloadFile(row)}><i class="bi bi-download"></i></span></div>;
            }
        }
    ];

    const defaultColumnOptions={
        resizable: true,
        width:'auto',
        cellClass: 'cell-center',
        headerCellClass: 'cell-center'
      }

    useEffect(()=>{
        axios.get(`/exportedfiles/${props.userid}`)
        .then(res => {
            const data=res.data.map((row,idx)=>{
                row.index=idx+1
                return row
            })
            setFiles(data);
        })
    },[])

    const saveNote = async () => {
        try {
            await axios.post('/exportedfiles', {
                id: selectedRow.id,
                notes: noteValue
            });

            // update grid locally
            setFiles(prev =>
            prev.map(f =>
                f.id === selectedRow.id ? { ...f, notes: noteValue } : f
            )
            );

            setShowModal(false);
        } catch (err) {
            console.error("Save failed", err);
        }
    };

    return (<>
        <div className="h-100">
            <div className='w-100 h-100 bg-white'>
                <DataGrid 
                    columns={filesColDefs} 
                    rows={files} 
                    // rowHeight={28} 
                    // headerRowHeight={32} 
                    className='h-100 w-100 rdg-light' 
                    defaultColumnOptions={defaultColumnOptions}
                    onCellContextMenu={({ row }, event) => handleRowContextMenu(row, event)}

                />
            </div>

        </div>

        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
            <Modal.Title>Edit Description</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control
                as="textarea"
                rows={5}
                value={noteValue}
                onChange={e => setNoteValue(e.target.value)}
            />
            </Form.Group>
        </Modal.Body>

        <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
            </Button>
            <Button variant="primary" onClick={saveNote}>
            Save
            </Button>
        </Modal.Footer>
        </Modal>


    </>)
}

export default Downloads